export default __webpack_public_path__ + "static/media/ace_of_corn.de4aa01f.png";